import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { WidgetConfig } from '@src/types/Widget';

interface UseGetWidgetConfigOptions {
  enabled?: boolean;
  queryKeys?: string[];
}

const useGetWidgetConfig = <T extends WidgetConfig>(
  id: string,
  options?: UseGetWidgetConfigOptions,
) =>
  useApiQuery<T>({
    queryKey: [QueryKeys.widgetConfig, id, ...(options?.queryKeys || [])],
    apiPath: `/widgets/${id}`,
    method: 'GET',
    useV2API: true,
    enabled: typeof options?.enabled === 'boolean' ? options.enabled : true,
    retry: false,
  });

export default useGetWidgetConfig;
